// Module
var code = "<front-royal-spinner ng-if=\"!playerViewModel.ready\" class=\"fixed\"></front-royal-spinner><show-frames-player ng-if=\"playerViewModel.ready\" player-view-model=\"playerViewModel\"></show-frames-player>";
// Exports
export default code;